export default "__VITE_ASSET__B46ut5tD__"